import { render } from "./SlideImagemApresentacao.vue?vue&type=template&id=4f3e8152&scoped=true"
import script from "./SlideImagemApresentacao.vue?vue&type=script&lang=js"
export * from "./SlideImagemApresentacao.vue?vue&type=script&lang=js"

import "./SlideImagemApresentacao.vue?vue&type=style&index=0&id=4f3e8152&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f3e8152"]])

export default __exports__